<template>
  <v-select
    :disabled="isDisabled"
    :value="value"
    :items="trialStatusValues"
    :menu-props="menuProps"
    :label="statusTerminology"
    data-e2e-id="edit-trial-status-dropdown"
    @input="$emit('input', $event)"
  >
    <template #item="{ item }">
      <v-chip :data-e2e-id="kebab(item.text) + '-status-selection'">
        <component :is="item.icon"></component>
        <b class="px-1">{{ item.text }}</b>
      </v-chip>
    </template>
    <template #selection="{ item }">
      <v-chip data-e2e-id="current-trial-status">
        <component :is="item.icon"></component>
        <b class="px-1">{{ item.text }}</b>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
import _ from 'lodash'
import { TrialStatus } from '@/helpers/trial-helper'
import TrialStatusFeasibilityIcon from '@/assets/icons/TrialStatusFeasibilityIcon'
import TrialStatusOpenIcon from '@/assets/icons/TrialStatusOpenIcon'
import TrialStatusSuspendedIcon from '@/assets/icons/TrialStatusSuspendedIcon'
import TrialStatusClosedIcon from '@/assets/icons/TrialStatusClosedIcon'
import TrialStatusMatchingIcon from '@/assets/icons/TrialStatusMatchingIcon'

export default {
  components: {
    TrialStatusFeasibilityIcon,
    TrialStatusOpenIcon,
    TrialStatusSuspendedIcon,
    TrialStatusClosedIcon,
    TrialStatusMatchingIcon
  },
  props: {
    value: { type: String, default: null },
    statusTerminology: { type: String, default: 'Trial/Practice Recruiting Status' },
    menuProps: { type: Object, default: () => {} }
  },
  computed: {
    isDisabled() {
      return this.isFeasibilitySelected || this.isMatchingSelected
    },
    isFeasibilitySelected() {
      return this.value === TrialStatus.FEASIBILITY.value
    },
    isMatchingSelected() {
      return this.value === TrialStatus.MATCHING.value
    },
    trialStatusValues() {
      return this.isFeasibilitySelected || this.isMatchingSelected
        ? _.map(TrialStatus)
        : _.filter(
            _.map(TrialStatus),
            status => status !== TrialStatus.FEASIBILITY && status !== TrialStatus.MATCHING
          )
    }
  },
  methods: {
    kebab(selector) {
      return _.kebabCase(selector)
    }
  }
}
</script>
